import { render, staticRenderFns } from "./TablaReporteMarketing.vue?vue&type=template&id=d1c1a4a4"
import script from "./TablaReporteMarketing.vue?vue&type=script&lang=js"
export * from "./TablaReporteMarketing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports